import { connect } from 'react-redux';

import GridSectionFilters from './grid_section_filters.jsx';

import {
  getAppliedTagIdsByCategoryIdForSection
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  setAppliedTagIdsByCategoryIdForGridSection
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

const mapStateToProps = (state, { section, gridTaxonomy })=> {
  const appliedTagIdsByCategoryId = getAppliedTagIdsByCategoryIdForSection(state, section);

  return {
    appliedTagIdsByCategoryId,
    categories: gridTaxonomy.categories,
    filterType: gridTaxonomy.filterMeta.type,
    filterToggleText: gridTaxonomy.filterMeta.toggleText
  };
};

const mapDispatchToProps = (dispatch, { section })=> {
  return {
    onSetSelectedTagIdsByCategoryId: (selectedTagIdsByCategoryId)=> {
      dispatch(setAppliedTagIdsByCategoryIdForGridSection(section.id, selectedTagIdsByCategoryId));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GridSectionFilters);
